import styled from "styled-components";

export const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RadioLabel = styled.span`
    display: block;
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
    font-family: "Helvetica";
    color: #595959;
`;

export const SegmentedContainer = styled.div`
  display: flex;
  background-color: #f1f3f5;
  border-radius: 8px;
  padding: 4px;
  width: fit-content;
  border: 1px solid #e9ecef;
`;

export const SegmentItem = styled.label<{ isChecked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  background-color: ${({ isChecked }) => (isChecked ? "#ffffff" : "transparent")};
  color: ${({ isChecked }) => (isChecked ? "#212529" : "#6c757d")};
  box-shadow: ${({ isChecked }) => (isChecked ? "0px 2px 4px rgba(0, 0, 0, 0.05)" : "none")};

  input {
    display: none;
  }

  &:hover {
    color: #212529;
  }
`;